import { makeAutoObservable } from 'mobx';

export class StateStore {
  public isSomeLoading = false;

  public get isGlobalLoader() {
    return this.isSomeLoading;
  }

  constructor() {
    makeAutoObservable(this);
  }
}
